export function Signature() {
  return (
    <div style={{ textAlign: 'center', marginTop: '8px' }}>
      <p>________________________________</p>
      <p>Assinatura</p>
    </div>
  );
}
